module.exports = __webpack_public_path__ + "img/article-image-3.eb3c5e03.webp";